import { State } from "components/bookShuffle/useBookShuffle/types";

export default function defaultState(overrides: Partial<State> = {}): State {
  const { books = [], ...otherOverrides } = overrides;

  // if there are no books, immediately show the end card.
  const currentIndex = books.length > 0 ? -1 : 0;

  return {
    isAnimating: false,
    currentIndex,
    books,
    showSkipConfirm: false,
    showAcceptedDialog: false,
    showRejectedDialog: false,
    distanceSwiped: 0,
    ...otherOverrides,
  };
}
